export const ENROLL_PLATFORM_TAB_ITEMS = [
  { value: "macos", label: "macOS" },
  { value: "windows", label: "Windows" },
  { value: "linux", label: "Linux" },
] as const;

export type EnrollPlatform = (typeof ENROLL_PLATFORM_TAB_ITEMS)[number]["value"];
